import { APIResponse, deleteRequest, getRequest, patchRequest, postRequest, putRequest } from '../../utils'
import { ShippingAddress } from '../contacts/types/shippingAddress'
import { Contact } from './types/contact'

interface AddressByIdResponseData {
  address: ShippingAddress
}

export const fetchAddressById = (addressId: string): Promise<AddressByIdResponseData> =>
  getRequest(`/v2/addresses/${addressId}`)

export const createAddress = (address: ShippingAddress): Promise<APIResponse<ShippingAddress>> =>
  postRequest('/v2/addresses', { address })

export const updateAddress = (address: Partial<ShippingAddress>): Promise<APIResponse<ShippingAddress>> =>
  patchRequest('/v2/addresses', { addresses: [address] })

export const createContact = (contact: Partial<Contact>): Promise<APIResponse<Contact>> =>
  postRequest('/v2/contacts', { contact })

export const updateContact = (contact: Partial<Contact>): Promise<APIResponse<Contact>> =>
  patchRequest('/v2/contacts', { contacts: [contact] })

export const updateContactFieldsById = (contactId: string, fields: Partial<Contact>): Promise<APIResponse<Contact>> =>
  putRequest(`/v2/contacts/${contactId}`, { contact: { id: contactId, ...fields } })

export const deleteContact = (contactId: string): Promise<void> => deleteRequest(`/v2/contacts/${contactId}`)

export interface ContactByIdResponseData {
  contact: Contact
}

export const fetchContactById = (contactId: string): Promise<ContactByIdResponseData> =>
  getRequest(`/v2/contacts/${contactId}?include=contact.contactPersons:embed`)
